import { useInfiniteQuery } from '@tanstack/react-query';
import {
  getSocialPostReplies,
  getSocialPostRootComments,
} from '@/src/actions/social-comments';

export function useSocialPostRootComments(postId: number, enabled = true) {
  return useInfiniteQuery({
    queryKey: ['postComments', postId, 'root'],
    enabled: enabled && !!postId,
    initialPageParam: null as { createdAt: string; id: number } | null,
    queryFn: async ({ pageParam }) => {
      return getSocialPostRootComments(postId, 10, pageParam);
    },
    getNextPageParam: (lastPage) => {
      return lastPage?.data?.nextCursor ?? undefined;
    },
    refetchOnWindowFocus: false,
  });
}

export function useSocialPostReplies(
  postId: number,
  parentId: number,
  enabled = true
) {
  return useInfiniteQuery({
    queryKey: ['postComments', postId, 'replies', parentId],
    enabled: enabled && !!postId && !!parentId,
    initialPageParam: null as { id: number } | null,
    queryFn: async ({ pageParam }) => {
      return getSocialPostReplies(postId, parentId, 10, pageParam);
    },
    getNextPageParam: (lastPage) => {
      return lastPage?.data?.nextCursor ?? undefined;
    },
    refetchOnWindowFocus: false,
  });
}
